<template>
    <background>
        <div class="flex-layout">
            <view-header
                    :title="lang('menu.survey')"
                    :action="goBackHeaderButton">

            </view-header>

            <div class="view p-lr">

                <template v-if="showPlaceholder">

                    <placeholder
                            icon="bar-chart"
                            :title="lang('views.survey.end-screen.title')"
                    >

                        <template v-slot:content>
                            {{ lang('views.survey.end-screen.content') }}
                        </template>

                        <template v-slot:button>
                            <c-button @click="goBack">
                                {{ lang('views.survey.end-screen.button.content') }}
                            </c-button>
                        </template>

                    </placeholder>
                </template>

                <template v-else>
                    <progress-bar :value="progressValue" :total="totalQuestions">

                    </progress-bar>

                    <div class="question">
                        <p>
                            {{ currentQuestion.title }}
                        </p>
                        <div class="answers">

                            <div v-for="answer in currentQuestion.answers"
                                 :key="answer.id"
                                 v-on:click="answerQuestion(currentQuestion.id, answer.id)"
                                 class="answer ripple"
                                 :class="{active: active === answer.id}">
                                <span class="dot"></span>
                                {{ answer.answer }}
                            </div>

                        </div>
                    </div>

                    <div class="chyron" v-show="chyron">
                        <icon icon="info"></icon>
                        <div class="text">
                            {{chyron}}
                        </div>
                    </div>

                    <div class="actions" :class="{'flex-end': checkIndex(0)}">
                        <c-button icon="chevrons-left"
                                  :glass-style="false"
                                  v-on:click="previousQuestion"
                                  :class="{'display-none': checkIndex(0)}"
                        >
                            {{ lang('views.survey.button.previous') }}
                        </c-button>
                        <c-button icon="chevrons-right"
                                  :icon-right="true"
                                  v-on:click="nextQuestion"
                                  :class="{
                                    'disabled': !hasAnsweredQuestion(currentQuestion.id)}">
                            {{ lang('views.survey.button.next') }}
                        </c-button>
                    </div>
                </template>


            </div>
        </div>

    </background>
</template>

<script>

import app from '../app';
import helpers from '../helpers'
import history from '../mixins/history'
import settings from "../settings";

export default {
    name: 'Survey',
    mixins: [history],
    data() {
        return {
            progressValue: 0,
            totalQuestions: null,

            survey: null,
            questions: null,
            chyron: null,
            chyronIndex: 0,

            currentQuestion: {
                id: null,
                question_title: null,
                answers: [{
                    id: null,
                    answer: null
                }]
            },
            answeredQuestions: [],
            currentIndex: 0,
            showPlaceholder: false,
        }
    },

    methods: {
        nextQuestion() {

            if(!this.hasAnsweredQuestion(this.currentQuestion.id))
                return;

            if (this.checkIndex(this.totalQuestions - 1)){
                if(settings.sendStatsToServer){
                    this.sendAnswers();
                    return 
                }
            }

            this.setQurrentQuestion(++this.currentIndex);
            this.progressValue++;
        },

        previousQuestion() {

            this.setQurrentQuestion(--this.currentIndex);
            this.progressValue--;
        },

        answerQuestion(currentQuestionId, answerId) {


            let elementInArray = this.indexOfAnsweredQueston(currentQuestionId);

            if (elementInArray === -1) {
                this.answeredQuestions.push(this.setAnswerQuestionObject(currentQuestionId, answerId));

            } else {
                this.answeredQuestions.splice(elementInArray, 1, this.setAnswerQuestionObject(currentQuestionId, answerId));
            }

        },

        setAnswerQuestionObject(currentQuestionId, answerId) {
            return {
                id: currentQuestionId,
                answerId: answerId,
            }
        },

        indexOfAnsweredQueston(currentQuestionId) {
            return this.answeredQuestions.findIndex(element => element.id === currentQuestionId);
        },

        hasAnsweredQuestion(currentQuestionId) {
            let index = this.indexOfAnsweredQueston(currentQuestionId);
            if (index === -1)
                return false;
            return true
        },

        setQurrentQuestion(currentIndex) {
            this.currentQuestion = this.questions[currentIndex];
        },

        checkIndex(index) {
            return this.currentIndex === index;
        },

        async sendAnswers() {

                this.showPlaceholder = true;

                let data = {
                    data: {
                        "answers" : JSON.parse(JSON.stringify(this.answeredQuestions)),
                        "survey": this.survey.id,
                    }
                };

                app.markSurveySubmitted(this.survey.id)

                await app.httpManager.request({
                    url: settings.serverBaseUri + '/api/user-survey-answers/',
                    method: 'post',
                    data: data,
                });

        },

        goBack() {

            this.buttonAction(-3)

        },

        goBackHeaderButton(){

            if(this.showPlaceholder){
                this.buttonAction();
            }

            return this.$router.back();

        },

        updateChyron(){

            if(this.survey.attributes.Chyron?.length){

                if(!this.survey.attributes.Chyron[this.chyronIndex])
                    this.chyronIndex = 0

                this.chyron = this.survey.attributes.Chyron[this.chyronIndex].text

                this.chyronIndex++

            }

        },

    },

    computed: {
        active() {
            let element = this.answeredQuestions.find(element => element.id === this.currentQuestion.id);
            if (element !== undefined)
                return element.answerId;
            return -1;
        }
    },

    beforeUnmount() {

        this.deinitializePopStateListener();

        if(this.chyronInterval)
            clearInterval(this.chyronInterval)

    },
    created() {
        
        let survey = this.strapiLocalizedResource(
            app.activeSurvey()
        );

        this.survey = JSON.parse(JSON.stringify(survey))

        this.questions = this.survey.attributes.Questions;

        this.totalQuestions = this.questions.length;
        this.currentQuestion = this.questions[0];

        this.chyronInterval = setInterval(() => {
            this.updateChyron()
        }, 10000)
        
        this.updateChyron();

        this.initializePopStateListener();
    },


}

</script>

<style lang="scss" scoped>
@import "../scss/includes.scss";

.display-none {
    display: none;
}

.separator {
    margin-top: 30px;
    margin-bottom: 40px;
}

.view {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-bottom: 40px;
}

.question {
    flex: 1;
    padding-top: 40px;;
    p {
        font-size: 1.0em;
        line-height: 1.4em;
        min-height: 120px;
    }

    .answers {
        .answer {
            @include glass-style();

            display: flex;
            align-items: center;
            border-radius: $default-border-radius-large;
            padding: 0px 20px;
            cursor: pointer;

            height: $form-one-line-input-height;

            &:not(:last-child) {
                margin-bottom: 10px;
            }

            &.active {
                @include glass-style-yellow();

                .dot {
                    background-color: rgba(255, 255, 255, 1);
                }
            }

            .dot {
                width: 7px;
                height: 7px;
                border-radius: 100%;
                display: block;
                background-color: rgba(255, 255, 255, 0.6);
                margin-right: 20px;

            }
        }
    }
}

.chyron{
    margin-top: 30px;
    margin-bottom: 20px;

    padding: 10px 15px;
    display: flex;
    align-items: center;

    .icon{
        margin-right: 15px;
        color: color(1, "yellow")
    }

    background-color: transparentize(color(1, "yellow"), 0.90);
    border: 1px solid transparentize(color(1, "yellow"), 0.8);
    border-radius: 5px;
    
    .text{
        font-size: 0.9em;
        font-weight: 500;
    }

}

.actions {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;

    &.flex-end {
        justify-content: flex-end;
    }
}
</style>
